<template>
  <button
    :class="[
      'cursor-pointer',
      'flex',
      'items-center',
      'text-md',
      hasPadding ? 'p-12' : undefined,
      disabled ? '' : 'hover:bg-surface-action-hover',
      'active:shadow-buttonSoft',
      disabled ? 'text-text-disabled' : 'text-text-primary',
      disabled ? 'bg-surface-disabled' : undefined,
      classes,
    ]"
    tabindex="0"
    lang="sv"
    :aria-label="ariaLabel"
  >
    <nuxt-icon
      :name="iconName"
      :class="[iconClasses, 'text-20']"
      aria-hidden="true"
    />
  </button>
</template>

<script lang="ts" setup>
interface Props {
  ariaLabel?: string;
  classes?: string;
  iconClasses?: string;
  hasPadding?: boolean;
  iconName: string;
  disabled?: boolean;
}
withDefaults(defineProps<Props>(), {
  ariaLabel: undefined,
  classes: '',
  iconClasses: '',
  hasPadding: true,
  disabled: false,
});
</script>

<style scoped lang="scss"></style>
